import { usePermissaoTurma } from "./usePermissaoTurma";

// Permissão "criar/editar eventos" por turma. Wrapper de usePermissaoTurma.
export function usePermissaoEventos(turmaId) {
  return usePermissaoTurma(turmaId, "podeCriarEditarEventos");
}

// Permissão "editar lista de alunos" por turma.
export function usePermissaoAlunos(turmaId) {
  return usePermissaoTurma(turmaId, "podeEditarListaAlunos");
}

// Permissão "gerenciar responsáveis" por turma.
export function usePermissaoResponsaveis(turmaId) {
  return usePermissaoTurma(turmaId, "podeGerenciarResponsaveis");
}
